interface ENV {
  BACKEND_API: string;
  APP_DOMAIN: string;
  APP_NAME: string;
  SC_DOMAIN: string;
}

const ENVIRONMENT: ENV = {
  BACKEND_API: process.env?.REACT_APP_BACKEND_API || '',
  APP_DOMAIN: process.env?.REACT_APP_APP_DOMAIN || '',
  APP_NAME: process.env?.REACT_APP_APP_NAME || '',
  SC_DOMAIN: process.env?.REACT_APP_SC_DOMAIN || '',
};
export default ENVIRONMENT;
